import { render } from "./BarraBotoes.vue?vue&type=template&id=403e1f8a&scoped=true&ts=true"
import script from "./BarraBotoes.vue?vue&type=script&lang=ts"
export * from "./BarraBotoes.vue?vue&type=script&lang=ts"

import "./BarraBotoes.vue?vue&type=style&index=0&id=403e1f8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403e1f8a"]])

export default __exports__